import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('system'); // 'light', 'dark', or 'system'
  const [isLight, setIsLight] = useState(false);

  // Function to get system theme preference
  const getSystemTheme = () => {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  };

  // Function to apply theme to document
  const applyTheme = (currentTheme) => {
    const effectiveTheme = currentTheme === 'system' ? getSystemTheme() : currentTheme;

    if (effectiveTheme === 'dark') {
      document.documentElement.classList.add('dark');
      setIsLight(false);
    } else {
      document.documentElement.classList.remove('dark');
      setIsLight(true);
    }
  };

  // Initialize theme from localStorage or use system default
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'system';
    setTheme(savedTheme);
    applyTheme(savedTheme);

    // Listen for system theme changes
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => {
      if (savedTheme === 'system') {
        applyTheme('system');
      }
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  // Apply theme whenever it changes
  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const handleMode = () => {
    const newTheme = isLight ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };

  const setSystemTheme = () => {
    setTheme('system');
    localStorage.setItem('theme', 'system');
  };

  return (
    <ThemeContext.Provider value={{ isLight, handleMode, theme, setSystemTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
